fragment moneyFields on Money {
  amount
  currency
}
